import React, { useEffect, useState } from "react";
import { PaymentPageWrapper, PaymentPageTopBar } from "./paymentsPage.styled";
import { IoFilterOutline } from "react-icons/io5";
import Button from "../../components/button";
import StatsBoxOne from "../../components/statsBox/statsBoxOne";
import { comapnyPaymentData, paymentsData } from "./constant/mokData";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import dayjs from "dayjs";
import * as XLSX from "xlsx";
import { SagaActions } from "../../redux/actionTypes";
import {
  getAllPaymentsReq,
  getAllTransactionReq,
  getPaymentsByMonthReq,
} from "../../api/payments/paymentReq";
import RenderIf from "../../components/renderIf";
import { MonthlyPaymentType, PaymentType } from "../../types/paymentTypes";
import MonthlyPaymentTable from "./components/monthlyPaymentTable";
import AllPaymentTable from "./components/allPaymentTable";

const statsData1 = [
  {
    label: "Offer Issues",
    numbers: "55,00",
    desc: "Dec 2023",
    inPercentage: false,
    inRupees: true,
  },
  {
    label: "Candidates",
    numbers: "2,44,000",
    desc: "Till Date",
    inPercentage: false,
    inRupees: true,
  },
];

type ThisMonth = [
  {
    month: string;
    year: number;
    totalAmount: number;
  }
];

interface TransactionDetails {
  allTime: number;
  thisMonth: ThisMonth;
}

export const PaymentsPage = () => {
  const Dispatch = useDispatch();
  const { clients } = useSelector((_state: RootState) => _state);

  const [allTransactionDetails, setallTransactionDetails] =
    useState<TransactionDetails>();
  const [monthPaymentDetails, setmonthPaymentDetails] = useState<
    MonthlyPaymentType[]
  >([]);
  const [allPaymentDetails, setallPaymentDetails] = useState<PaymentType[]>([]);

  const downloadXls = (data: any) => {
    const workbook = XLSX.utils.book_new();

    const modifiedData = data.map((item: any, index: any) => {
      const timestamp = new Date(item["receivedDate"]);
      const formattedReceivedDate = `${timestamp.toLocaleString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      })}`;
      return {
        // "Amount ": item["amount"],
        // "Company Name": item.company["companyName"],
        // "Received Date": formattedReceivedDate,
        // "Transaction Details": item["txnDetails"],
        "Sl. No": index + 1,
        "Received Date": formattedReceivedDate,
        "Company Name": item.company["companyName"],
        "Amount ": item["amount"],
        "Descriptions ": item["txnDetails"],
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(modifiedData);

    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // const blob = XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
    const fileName = `PaymentsList_${dayjs(new Date()).format(
      "YYYYMMDD_hhmmss"
    )}.xlsx`;

    const buffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "buffer",
    });
    XLSX.write(workbook, { bookType: "xlsx", type: "binary" });

    XLSX.writeFile(workbook, fileName);
  };

  const getAllTransaction = async () => {
    try {
      const res = await getAllTransactionReq();
      console.log("all transaction", res.data);
      setallTransactionDetails(res.data);
      Dispatch({
        type: SagaActions.INFO,
        payload: {
          env: "prod",
          message: res?.message,
          fileName: "paymentsPage",
          methodName: "getAllPayments",
          type: "info",
        },
      });
    } catch (error: any) {
      Dispatch({
        type: SagaActions.ERROR,
        payload: {
          env: "prod",
          message: error?.errorMsg,
          fileName: "paymentsPage",
          methodName: "getAllPayments",
          type: "error",
        },
      });
    }
  };

  const getPaymentsByMonth = async () => {
    try {
      const res = await getPaymentsByMonthReq();
      setmonthPaymentDetails(res.data);
      Dispatch({
        type: SagaActions.INFO,
        payload: {
          env: "prod",
          message: res?.message,
          fileName: "paymentsPage",
          methodName: "getPaymentsByMonth",
          type: "info",
        },
      });
    } catch (error: any) {
      Dispatch({
        type: SagaActions.ERROR,
        payload: {
          env: "prod",
          message: error?.errorMsg,
          fileName: "paymentsPage",
          methodName: "getPaymentsByMonth",
          type: "error",
        },
      });
    }
  };

  const getAllPayments = async () => {
    try {
      const res = await getAllPaymentsReq();
      setallPaymentDetails(res.data);
      Dispatch({
        type: SagaActions.INFO,
        payload: {
          env: "prod",
          message: res?.message,
          fileName: "paymentsPage",
          methodName: "getAllPayments",
          type: "info",
        },
      });
    } catch (error: any) {
      Dispatch({
        type: SagaActions.ERROR,
        payload: {
          env: "prod",
          message: error?.errorMsg,
          fileName: "paymentsPage",
          methodName: "getAllPayments",
          type: "error",
        },
      });
    }
  };

  useEffect(() => {
    getAllTransaction();
    getPaymentsByMonth();
    getAllPayments();
  }, []);

  return (
    <PaymentPageWrapper className="p-2">
      <PaymentPageTopBar className="px-4 py-2">
        <div className="bar_title">
          <p className="lg-text">Summary:</p>
        </div>
      </PaymentPageTopBar>
      <div className="d-flex p-3">
        {allTransactionDetails?.thisMonth?.map((item, idx) => (
          <StatsBoxOne
            key={idx}
            label={"This Month"}
            numbers={item.totalAmount}
            desc={`${item.month} ${item.year}`}
            inPercentage={false}
            inRupees={true}
            className="mx-2"
          />
        ))}
        {allTransactionDetails?.allTime && (
          <StatsBoxOne
            // key={idx}
            label={"All Time"}
            numbers={allTransactionDetails?.allTime || 0}
            desc={"Till Date"}
            inPercentage={false}
            inRupees={true}
            className="mx-2"
          />
        )}
      </div>
      <div className="row p-3">
        <div className="w-100 p-0">
          <div className="shadow-block bg-white p-3 ms-3 mt-3 me-3 rounded">
            <div className="d-flex justify-content-between">
              <p className="m-1 md-text">Full Lists of payments:</p>
              {/* <Button
                label="Export"
                onClick={() => downloadXls(allPaymentDetails)}
                outline
                borderColor="primary"
                className={"px-3"}
              /> */}
              <button
                className={`primary-border bg-white rounded px-3 d-flex align-items-center mx-3`}
                onClick={() => downloadXls(allPaymentDetails)}
              >
                {/* <AiOutlineDownload /> */}
                <span className={`sm-text primary-color`}>Export</span>
              </button>
            </div>
            <div className="p-2"></div>
            <RenderIf isShow={allPaymentDetails?.length > 0}>
              <AllPaymentTable tableData={allPaymentDetails} />
            </RenderIf>
            <RenderIf isShow={allPaymentDetails?.length < 1}>
              <div className="w-100 d-flex align-items-center justify-content-center">
                <p className="text-secondary m-3">-: No Data :-</p>
              </div>
            </RenderIf>
          </div>
        </div>
        <div className="w-50 p-0">
          <div className="shadow-block bg-white p-3 ms-3 mt-3 me-2 rounded">
            <p className="m-1 md-text">Payments (by Month):</p>
            <div className="p-2"></div>
            <RenderIf isShow={monthPaymentDetails?.length > 0}>
              <MonthlyPaymentTable tableData={monthPaymentDetails} />
            </RenderIf>
            <RenderIf isShow={monthPaymentDetails?.length < 1}>
              <div className="w-100 d-flex align-items-center justify-content-center">
                <p className="text-secondary m-3">-: No Data :-</p>
              </div>
            </RenderIf>
          </div>
        </div>
      </div>
      {/* <Row className="h-100">
        <Col lg={6} className="h-100">
          <div className="d-flex p-3">
            {statsData1.map((item, idx) => (
              <StatsBoxOne
                key={idx}
                label={item.label}
                numbers={item.numbers}
                desc={item.desc}
                inPercentage={item.inPercentage}
                inRupees={item.inRupees}
                className="mx-2"
              />
            ))}
          </div>
          <div className="d-flex p-2">
            <div className="w-100 p-3">
              <p className="m-1 lg-text">
                <u>Payments (by Month):</u>
              </p>
              <div className="p-1"></div>
              {monthPaymentDetails.map((item, idx) => (
                <div className=" m-1 my-3 " key={idx}>
                  <p className="sm-text">
                    <b>{item?.month}</b> <b>{item?.year}</b>
                  </p>
                  <p>
                    {item.totalAmount} | {item?.transactionCount} Payments
                  </p>
                </div>
              ))}
            </div>
          </div>
        </Col>
        <Col lg={6} className="h-100">
          <div
            className="d-flex p-2 h-100"
            style={{ borderLeft: "1px solid gray" }}
          >
            <div className="w-100 p-3">
              <div className="d-flex justify-content-between">
                <p className="m-1 lg-text">
                  <u>The Full List:</u>
                </p>
                <Button
                  label="Export"
                  onClick={() => {}}
                  outline
                  borderColor="primary"
                  className={"px-3"}
                />
              </div>
              <div className="p-1"></div>
              {allPaymentDetails.map((item, idx) => (
                <div className=" m-1 my-3 " key={idx}>
                  <p className="sm-text">
                    <b>{item?.amount}</b> | {item.companyName}
                  </p>
                  <p>
                    {dayjs(item.receivedDate).format(
                      "MMM DD, YYYY"
                    )}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </Col>
      </Row> */}
    </PaymentPageWrapper>
  );
};
